export default __webpack_public_path__ + "static/media/Party.5cbe3486.svg";